import { Configuration, FilteringAttribute } from '@encomply/components/dashboard-settings/dashboard-filtering-attributes-dialog.component';

import { Dashboard } from '../../interface/dashboard.interface';

export const dashboardState: DashboardState = {
    currentOrganizationId: '',
    selectedDashboard: undefined,
    analyticDashboards: {},
    isDashboardsLoading: undefined,
};

export interface DashboardState {
    currentOrganizationId: string;
    selectedDashboard: Dashboard;
    analyticDashboards: {
        // orgid vs details
        [property: string]: {
            dashboards: [];

            dashboardDetails: {
                // serviceId vs dashboardDetails
                [property: string]: {
                    configuration: Configuration;
                    metadata: FilteringAttribute[];
                };
            };
        };
    };
    isDashboardsLoading: boolean;
}
